import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  BookWidgetSearchModalComponent,
  PredictiveSearch,
  RecentListItem
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { GenericAction, SelectedData, Tab } from '@com-delta-omnichannel/mach';
import {
  PredictiveSearchItemSelectionEventData,
  SearchModalEvent,
  SearchModalEventType
} from '../../../models/search-modal-events-object.interface';
import { ErrorStateDirective } from '../directive';

@Component({
  standalone: true,
  selector: 'idp-connection-picker',
  templateUrl: './connection-picker.component.html',
  styleUrls: ['./connection-picker.component.scss'],
  imports: [BookWidgetSearchModalComponent, NgIf, ErrorStateDirective]
})
export class ConnectionPickerComponent {
  protected modalOpen = false;
  protected errorMessage = '';
  @Input() connection!: { connectionCity: string; connectionAirport: string };
  @Input() recentSearchList: RecentListItem[] = [];
  @Input() savedSearchList: string[] = [];
  @Input() searchModalTabs: Tab[] = [];
  @Input() predictiveSearchData!: PredictiveSearch;
  @Input() placeholder!: string;
  @Input() helpIconAriaLabel = '';
  @Input() isFullscreen = false;
  @Input() routeIndex = 0;
  @Input() set connectionError(errors: { errorMessage: string }[] | undefined) {
    if (errors && errors.length > 0) {
      this.errorMessage = errors[this.routeIndex].errorMessage;
    }
  }

  @Output() connectionInputClicked = new EventEmitter<void>();
  @Output() searchModalEvent = new EventEmitter<
    SearchModalEvent<SearchModalEventType>
  >();

  @Output() searchModalTriggerClicked = new EventEmitter<SelectedData>();

  @Output() showConnectionAirportInfoModal = new EventEmitter();
  @Output() clearConnectionAirport = new EventEmitter();

  protected handleModalEvents(event: SearchModalEvent<SearchModalEventType>) {
    this.searchModalEvent.emit(event);
  }

  protected handleSearchModalTrigger() {
    this.modalOpen = true;
    this.searchModalTriggerClicked.emit({
      type: 'connection',
      selectedResult: {
        cityCode: this.connection.connectionAirport,
        cityName: this.connection.connectionCity,
        region: ''
      }
    });
  }

  protected handlePredictiveSearchItemselection(
    eventData: GenericAction<string>
  ) {
    const data: PredictiveSearchItemSelectionEventData = {
      airportCode: eventData.label,
      airportCity: eventData.value ?? '',
      locationType: 'connection',
      flightIndex: this.routeIndex
    };

    this.searchModalEvent.emit({
      type: 'predictiveSearchItemSelected',
      data
    });
  }

  protected handleSearchModalClose(searchText: string) {
    if (searchText) {
      this.handlePredictiveSearchItemselection({
        label: searchText.toUpperCase(),
        id: searchText.toUpperCase(),
        value: ''
      });
    }

    this.modalOpen = false;
  }

  clearConnectionAirportHandler(event: Event) {
    this.clearConnectionAirport.emit();
    event.stopPropagation();
  }

  showConnectionAirportInfoModalHandler(event: Event) {
    this.showConnectionAirportInfoModal.emit();
    event.stopPropagation();
  }
}
